const queryString = require('query-string');

export class UrlService {

    constructor(options) {
        const urlParams = queryString.parse(location.search)

        //mandatory parameters
        this.state = urlParams['s']; // two digit state fips
        this.regionType = urlParams['r']; //can be county or watershed
        this.geoid = urlParams['c']; //county/watershed geoid
        this.fromYear = urlParams['fr']; //start year
        this.toYear = urlParams['to']; //end year

        //optional parameters
        this.tab = urlParams['t'] || 1;
        this.x = urlParams['x']; //map center x coordinate
        this.y = urlParams['y']; //map center y coordinate
        this.z = urlParams['z']; //map center z coordinate

        this.initialParams = {};
        if (this.hasNecessaryParametersInURL()) {
            this.initialParams.app = {};
            this.initialParams.app.state = (this.state.length == 1 ? String('0'+this.state) : this.state);
            this.initialParams.app.regionType = this.regionType;
            this.initialParams.app.geoid = this.geoid;
            this.initialParams.app.fromYear = this.fromYear;
            this.initialParams.app.toYear = this.toYear;
            this.initialParams.app.tab = this.tab;
        }

        if (this.hasMapParametersInURL()) {
            this.initialParams.map = {};
            this.initialParams.map.x = this.x;
            this.initialParams.map.y = this.y;
            this.initialParams.map.z = this.z;
        }

        //return initialParams;
    }

    hasNecessaryParametersInURL() {
        return (this.state && this.regionType && this.geoid && this.fromYear && this.toYear)
    }

    hasMapParametersInURL() {
        return (this.x && this.y && this.z)
    }

    async generateShareURL(appState) {
        const shareHash = {
            's': appState.stateFIPS,
            'r': appState.regionType === 'counties' ? 'county' : 'watershed',
            'c': appState.geoid,
            'fr': appState.fromYear,
            'to': appState.toYear,
            't': appState.tab
            /* ,
            'x': this.initialParams.map.x,
            'y': this.initialParams.map.y,
            'z': this.initialParams.map.z */
        }
        const params = queryString.stringify(shareHash);

        let shareUrl = `${location.protocol + '//' + location.host + location.pathname}?${params}`
        // shareUrl = shareUrl.replace('localhost', '127.0.0.1');//as bitly does not allow localhost urls

        // const bitlyRequest = `https://api-ssl.bitly.com/v3/shorten?access_token=${bitly.apiKey}&longUrl=${encodeURIComponent(shareUrl)}`;
        // const apiResponseData = (await (await fetch(bitlyRequest)).json()).data.url;
        //const apiResponseData = (await apiResponse.json()).data.url;
        return shareUrl;
    }
}